/* Next */
import { GetStaticProps } from 'next'

/* Types */
import { tBrands, isBrandsResponse } from 'src/shared/frontendTypes/brand'
import { MenuPageBuilder } from 'src/shared/dbTypes/menuPageBuilder'
import { LandingPageProductInquirySettings } from 'src/shared/dbTypes/landingPageSettings'

/* Functions */
import { post } from 'src/functions/fetch'

/* Options */
import config from 'src/config'
import { fetchSiteShopSettings } from 'src/pageBuilder/sitePageBuilder'

import Brands from 'src/pages/Brands/Brands'

interface Props {
  brands: tBrands
  sitePageBuilder?: MenuPageBuilder
  productInquiry?: LandingPageProductInquirySettings
}

export const getStaticProps: GetStaticProps<Props> = async () => {
  const siteSettings = await fetchSiteShopSettings({ local: true })

  const data = await post({
    url: `brands`,
    body: {
      ...config.shop,
      size: config.cache_static_brands_size,
    },
    local:true,
  })

  if (!isBrandsResponse(data)) {
    console.error('Kann Marken nicht laden!', data)
    return {
      props: {
        brands: [],
        ...(siteSettings.sitePageBuilder ? { sitePageBuilder: siteSettings.sitePageBuilder } : {}),
        ...(siteSettings.productInquiry ? { productInquiry: siteSettings.productInquiry } : {}),
      },
      revalidate: 60,
    }
  }

  return {
    props: {
      brands: data.brands,
      ...(siteSettings.sitePageBuilder ? { sitePageBuilder: siteSettings.sitePageBuilder } : {}),
      ...(siteSettings.productInquiry ? { productInquiry: siteSettings.productInquiry } : {}),
    },
    revalidate: 60,
  }

}

export default Brands
